import { render, staticRenderFns } from "./wechatpay.vue?vue&type=template&id=74ae3a45&scoped=true&"
import script from "./wechatpay.vue?vue&type=script&lang=js&"
export * from "./wechatpay.vue?vue&type=script&lang=js&"
import style0 from "./wechatpay.vue?vue&type=style&index=0&id=74ae3a45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae3a45",
  null
  
)

export default component.exports